module.exports = __webpack_public_path__ + "assets/facebook-footer-3f5655.svg";